import { FC, useEffect, useRef, useState } from "react";
import "./newCustomer.css";
import { CheckoutOrder } from "../../components/checkoutOrder/checkoutOrder";
import { Header } from "../../components/Header";
import { ConfigType, PluginconfigType } from "../../contexts/AppConfigContext";
import { useAppConfig } from "../../hooks/useAppConfig";
import { Input } from "../../components/inputs/inputs";
import { Loading } from "../../components/Loading";
import { ButtonCheckout } from "../../components/buttonCheckout/ButtonCheckout";
import {
  cepNoMask,
  cpfCnpjNoMask,
  rtcToText,
  telephoneNoMask,
} from "../../functions/mask";
import { cnpj, cpf } from "cpf-cnpj-validator";
import { useOrder } from "../../hooks/useOrder";
import { usePluginspace } from "../../hooks/usePluginspace";
import api from "../../services/api";
import Swal from "sweetalert2";
import { BsChevronUp, BsChevronDown } from "react-icons/bs";
import { CustomerType } from "../../contexts/OrderContext";
import { useNavigate, useParams } from "react-router-dom";
import { NewModalTerms } from "../../components/ModalTerms";

/*Toast */
import { Slide, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ModalConfirmWpp } from "../../components/ModalConfirmWpp";

type configField = {
  visible: boolean;
  mandatory: boolean;
  name: string;
  fieldName: string;
};

const NewCustomer: FC<any> = () => {
  const {
    getCustomer,
    setCustomer,
    getType,
    getOrderAddress,
    synchronizeContextToStorage,
    getCustomerAdress,
    changeCustomerDocument,
  } = useOrder();
  const { getToken, registerAccess, getThisPluginspace } = usePluginspace();
  const orderContext = useOrder();

  /**variavel para fazer controle do step do cadastro */
  const [step, setStep] = useState(1);

  /*Variavel usado para movimentar entre as paginas do WebApp */
  const navigate = useNavigate();
  const { pluginspace_id } = useParams();

  /* Variavel para abri ou fechar as infos do usuario */
  const [showCustomer, setShowCustomer] = useState(true);
  /* Variavel para abri ou fechar as infos do usuario - Endereço */
  const [showCustomerAddress, setShowCustomerAddress] = useState(true);

  const [config, setConfig] = useState<ConfigType | void>();
  const [loadingHeader, setLoadingHeader] = useState(true);
  const [loading, setLoading] = useState(true);
  const { getAppConfig } = useAppConfig();

  /*Variaveis para cada campo, junto com seus alertas */
  const [cpfOrCnpj, setCpfOrCnpj] = useState("");
  const [alarmCpf, setAlarmCpf] = useState(false);

  const [name, setName] = useState("");
  const [alarmName, setAlarmName] = useState(false);

  const [email, setEmail] = useState("");
  const [alarmEmail, setAlarmEmail] = useState(false);

  const [birthdate, setBirthdate] = useState("");
  const [alarmBirthdate, setAlarmBirthdate] = useState(false);

  const [telephone, setTelephone] = useState("");
  const [alarmTelephone, setAlarmTelephone] = useState(false);

  const [gender, setGender] = useState("masculino");

  const [useWpp, setUseWpp] = useState(false);

  /*Varialve usado para saber se aceitou os termo ou não */
  const [acceptTerm, setAcceptTerm] = useState(false);
  const [openTerms, setOpenTerms] = useState(false);
  const [term, setTerm] = useState("");
  const [alarmAccepTerm, setAlarmAccepTerm] = useState(false);
  const [readTerm, setReadTerms] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState("cpf");
  const [documentBlocked, setDocumentBlocked] = useState("");

  const [isTotvsFashion, setIsTotvsFashion] = useState(false);

  const [address, setAddress] = useState({
    zipCode: "",
    street: "",
    number: "0",
    district: "",
    city: "",
    state: "",
    extra: "",
    reference: "",
    typeAddress: "main",
    ibge: "",
  });

  /*Alarmes Usados no componente de Endereço */
  const [zipCodeAlarm, setAlarmZipCode] = useState(false);
  const [stateAlarm, setStateAlarm] = useState(false);
  const [streetAlarm, setStreetAlarm] = useState(false);
  const [cityAlarm, setCityAlarm] = useState(false);
  const [extraAlarm, setExtraAlarm] = useState(false);
  const [numberAlarm, setNumberAlarm] = useState(false);
  const [bairroAlarm, setBairroAlarm] = useState(false);

  const [activeAlarm, setActiveAlarm] = useState(false);

  /** Usado quando é CNPJ */
  const [inscEstadual, setInscEstadual] = useState("");

  /** Usado para identifcar o tipo da Loja */
  const [typePluginSpace, setTypePluginSpace] = useState("");
  const [type, setType] = useState("");

  const [customerAddresses, setCustomerAddresses] = useState([]);

  const [haveFieldConfig, setHaveFieldConfig] = useState(false);
  const [fieldsConfig, setFieldsConfig] = useState<configField[]>([]);
  const [wppAvaiable, setWppAvaiable] = useState(false);

  const [openConfirmWpp, setOpenConfirmWpp] = useState(false);
  const [codeWpp, setCodeWpp] = useState("");
  const [confirmWpp, setConfirmWpp] = useState(false);

  const findCustomerFromCart = useRef(false);

  const [customerId, setCustomerId] = useState<string | undefined>();
  const [customerValidationRegister, setCustomerValidationRegister] =
    useState(false);
  const [confirmValidationRegister, setConfirmValidationRegister] =
    useState(false);

  async function verifyTotvsFashion() {
    await api
      .post(
        `/api/pluginconfig/filter`,
        {
          plugintemplateId: 23,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        if (response.data.data.length > 0) {
          const configData: PluginconfigType = response.data.data[0];
          if (configData.content.able === "1") {
            setIsTotvsFashion(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function clearAllCustomer() {
    setName("");
    setEmail("");
    setBirthdate("");
    setGender("masculino");
    setTelephone("");
    setAddress({
      zipCode: "",
      street: "",
      number: "0",
      district: "",
      city: "",
      state: "",
      extra: "",
      reference: "",
      typeAddress: "main",
      ibge: "",
    });
    setCpfOrCnpj("");
  }

  function clearCustomer() {
    setName("");
    setEmail("");
    setBirthdate("");
    setGender("masculino");
    setTelephone("");
    setAddress({
      zipCode: "",
      street: "",
      number: "0",
      district: "",
      city: "",
      state: "",
      extra: "",
      reference: "",
      typeAddress: "main",
      ibge: "",
    });
  }

  async function getTermsTotvs() {
    return await api
      .get(`/api/letter-consent`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        const totvsRes = response.data;
        if (totvsRes && totvsRes.data && totvsRes.data.body) {
          setTerm(rtcToText(totvsRes.data.body));
          return true;
        } else {
          return false;
        }
      })
      .catch((err) => {
        return false;
      });
  }

  async function getTerms() {
    const hasTotvsTerms = await getTermsTotvs();
    if (!hasTotvsTerms) {
      await api
        .post(
          `/api/consent/filter`,
          {
            active: true,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          setTerm(response.data.data[0].content);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  async function findCustomer() {
    if (
      cpfOrCnpj === undefined ||
      cpfOrCnpj[0] === "_" ||
      (selectedDoc === "cpf" && !cpf.isValid(cpfOrCnpj)) ||
      (selectedDoc === "cnpj" && !cnpj.isValid(cpfOrCnpj))
    ) {
      setAlarmCpf(true);
      return;
    } else {
      setAlarmCpf(false);
    }
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(cpfOrCnpj);
    changeCustomerDocument(cpfWithouthMask);
    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then(async (response) => {
        setLoading(false);
        if (response.data.data.length > 0) {
          const data = response.data.data[0];

          if (
            (data.customerStatus && data.customerStatus === "Bloqueado") ||
            (data.status && data.status === "blocked")
          ) {
            setDocumentBlocked(data.doc);
            Swal.fire({
              icon: "warning",
              title: "Atenção!",
              text: "Seu cadastro está inativo. Entre em contato com a loja.",
            });
            clearAllCustomer();
            return;
          }

          if (data.name) setAlarmName(false);
          else setAlarmName(true);
          setName(data.name);

          // setUseWpp(data.optinWhatsapp);

          if (data.id) setCustomerId(data.id);

          if (data.validateRegister)
            setCustomerValidationRegister(data.validateRegister);

          if (data.email) setAlarmEmail(false);
          else setAlarmEmail(true);
          setEmail(data.email);

          if (data.birthDate) {
            setAlarmBirthdate(false);
            setBirthdate(data.birthDate.split("T")[0]);
          } else setAlarmBirthdate(true);

          if (data.gender) {
            setGender(data.gender.toLowerCase());
          } else {
            setGender("masculino");
          }

          if (data.inscEstadual) {
            setInscEstadual(data.inscEstadual);
          }

          if (data.customerPhones[data.customerPhones.length - 1].numberPhone)
            setAlarmTelephone(false);
          else setAlarmTelephone(true);
          setTelephone(
            data.customerPhones[data.customerPhones.length - 1].numberPhone
          );
          if (data.customerAddresses && data.customerAddresses.length > 0) {
            let customerAddressFinded = data.customerAddresses.find(
              (address: any) => address.typeAddress === "main"
            );
            let zipCode =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.zipCode
                : data.customerAddresses[0].zipCode;
            let street =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.street
                : data.customerAddresses[0].street;
            let number =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.number
                : data.customerAddresses[0].number;
            let extra =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.extra
                : data.customerAddresses[0].extra;
            let reference =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.reference
                : data.customerAddresses[0].reference;
            let district =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.district
                : data.customerAddresses[0].district;
            let city =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.city
                : data.customerAddresses[0].city;
            let state =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.state
                : data.customerAddresses[0].state;
            let ibge =
              customerAddressFinded && !isTotvsFashion
                ? customerAddressFinded.ibgeCode
                : data.customerAddresses[0].ibgeCode;
            setAddress({
              zipCode: zipCode,
              street: street,
              number: number,
              district: district,
              city: city,
              state: state,
              extra: extra ? extra : "",
              reference: reference ? reference : "",
              typeAddress: "main",
              ibge: ibge,
            });

            setCustomerAddresses(data.customerAddresses);
          }

          setStep(2);
        } else {
          setStep(1);
          clearCustomer();
        }
      })
      .catch((err) => {
        clearAllCustomer();
        setStep(1);
        setLoading(false);
        console.log(err);
      });
  }

  async function loadOrder() {
    await synchronizeContextToStorage();
    await getToken();
    const customer = await getCustomer();

    if (customer.wppNotification) setUseWpp(customer.wppNotification);
    if (customer.name) setName(customer.name);
    if (customer.email) setEmail(customer.email);
    if (customer.cpf) setCpfOrCnpj(customer.cpf);
    if (customer.birthdate) setBirthdate(customer.birthdate);
    if (customer.gender) setGender(customer.gender);
    if (customer.telephone) setTelephone(customer.telephone);

    setAddress({
      zipCode: customer.cep ? customer.cep : "",
      street: customer.address ? customer.address : "",
      number: customer.number ? customer.number : "",
      district: customer.district ? customer.district : "",
      city: customer.city ? customer.city : "",
      state: customer.state ? customer.state : "",
      extra: customer.complement ? customer.complement : "",
      reference: "",
      typeAddress: "main",
      ibge: customer.ibge ? customer.ibge : "",
    });

    const newType = await getType();
    setType(newType);
    const typePlugin = await getThisPluginspace();

    setTypePluginSpace(typePlugin!.type);
  }

  function validateFields() {
    try {
      let needToVerify = {
        email: true,
        telephone: true,
        birthdate: true,
      };
      if (haveFieldConfig && fieldsConfig) {
        const emailField = fieldsConfig.find(
          (field: configField) => field.name === "email"
        );
        const birthField = fieldsConfig.find(
          (field: configField) => field.name === "dataNascimento"
        );
        const phoneField = fieldsConfig.find(
          (field: configField) => field.name === "telefone"
        );
        needToVerify.email =
          emailField &&
          emailField.mandatory === true &&
          emailField.visible === true
            ? true
            : false;
        needToVerify.telephone =
          phoneField &&
          phoneField.mandatory === true &&
          phoneField.visible === true
            ? true
            : false;
        needToVerify.birthdate =
          birthField &&
          birthField.mandatory === true &&
          birthField.visible === true
            ? true
            : false;
      }

      if (telephone.includes("_") && needToVerify.telephone) {
        setAlarmTelephone(true);
        callToast("warning", `Telefone inválido`);
        setTelephone("");
        return {
          success: false,
          data: {},
        };
      }

      if (address.zipCode.includes("_")) {
        setAlarmZipCode(true);
        callToast("warning", `CEP inválido`);
        setAddress({ ...address, zipCode: "" });
        return {
          success: false,
          data: {},
        };
      }

      // Verifica se possui sobrenome
      if (
        name.split(" ").length < 2 ||
        !name.split(" ")[1] ||
        name.split(" ")[1] === ""
      ) {
        setAlarmName(true);
        callToast("warning", `Nome inválido, necessário um sobrenome`);
        return {
          success: false,
          data: {},
        };
      }

      if (cpfOrCnpj.includes("_")) {
        setAlarmCpf(true);
        callToast("warning", `CPF/CNPJ inválido`);
        setCpfOrCnpj("");
        return {
          success: false,
          data: {},
        };
      }

      if (!email.includes("@") && needToVerify.email) {
        setAlarmEmail(true);
        callToast("warning", `Email inválido`);
        setEmail("");
        return {
          success: false,
          data: {},
        };
      }

      if (cpfOrCnpj.length <= 14 && !cpf.isValid(cpf.strip(cpfOrCnpj))) {
        setAlarmCpf(true);
        callToast("warning", `CPF/CNPJ inválido`);
        return {
          success: false,
          data: {},
        };
      } else if (cpfOrCnpj.length > 14 && !cnpj.isValid(cpfOrCnpj)) {
        setAlarmCpf(true);
        callToast("warning", `CPF/CNPJ inválido`);
        return {
          success: false,
          data: {},
        };
      }

      return {
        success: true,
        data: {},
      };
    } catch (error) {
      return {
        success: false,
        error: error,
      };
    }
  }

  const updateCartWithCustomer = async () => {
    if (orderContext.shouldUpdadeCart) {
      const link = `${window.location.origin}/${
        window.location.pathname.split("/")[1]
      }/cart`;

      if (orderContext.guidCart) {
        //update
        /*
        1- Recuperar o carrinho pelo guidCart
        2- Atualizar Produtos, endereços Type e Freight
        */

        let customerCart: any = {};

        const tokenAccess = await getToken();
        const newOrder = await orderContext.getOrder();

        setLoading(true);

        await api
          .get(`/api/customerCart/guid/${orderContext.guidCart}`, {
            headers: {
              Authorization: `Bearer ${tokenAccess}`,
            },
          })
          .then(async (response) => {
            customerCart = response.data.data[0];
          })
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });
        const objCustomerCart = {
          customerName: name,
          cpfCustomer: cpfCnpjNoMask(cpfOrCnpj),
          phoneCustomer: telephoneNoMask(telephone),
          jsonCart: customerCart.jsonCart,
          locationId: customerCart.locationId,
          guid: customerCart.guidCart,
        };

        objCustomerCart.jsonCart.products = newOrder!.products;

        await api
          .put(`/api/customerCart/${customerCart.id}`, objCustomerCart, {
            headers: {
              Authorization: `Bearer ${tokenAccess}`,
            },
          })
          .then(async (response) => {})
          .catch((err) => {
            console.log(err);
            setLoading(false);
          });

        setLoading(false);

        return;
      }

      return;
    }
  };

  function shouldChangeOrderAddressCEP(customer: any) {
    if (
      typePluginSpace === "fashion" &&
      customer.shouldChangeAdressResultFashion
    ) {
      localStorage.setItem(
        "shouldChangeAddressFashion",
        customer.shouldChangeAdressResultFashion
      );
    }
  }

  async function sendCustomer() {
    try {
      setLoading(true);
      const newAddress = address;

      newAddress.zipCode = cepNoMask(address.zipCode);
      const customerToSend = {
        name: name,
        email: email,
        phones: [
          {
            typePhone: "cell",
            numberPhone: telephoneNoMask(telephone),
          },
        ],
        doc: cpfCnpjNoMask(cpfOrCnpj),
        cpf: cpfCnpjNoMask(cpfOrCnpj),
        optinWhatsapp: useWpp ? true : false,
        validateRegister: confirmValidationRegister,
        birthDate: birthdate,
        gender: gender,
        lgpdDataAceiteCarta: new Date(),
        password: "",
        inscEstadual,
        addresses: [newAddress],
        pluginconfigId: config?.content.pdv.pluginconfigId
          ? config?.content.pdv.pluginconfigId
          : 0,
      };

      await api
        .post(`/api/customer`, customerToSend, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response) => {
          setLoading(false);
          if (response.data.success === true) {
            let customer: CustomerType = {
              id: response.data.dados.id
                ? response.data.dados.id
                : response.data.dados.dados.id,
              name,
              email,
              cpf: cpfOrCnpj,
              birthdate,
              wppNotification: useWpp,
              validateRegister: confirmValidationRegister,
              acceptTermDate: response.data.dados.lgpdDataAceiteCarta
                ? response.data.dados.lgpdDataAceiteCarta
                : response.data.dados.dados.lgpdDataAceiteCarta,
              gender,
              telephone,
              cep: address.zipCode,
              address: address.street,
              district: address.district,
              city: address.city,
              state: address.state,
              number: address.number,
              complement: address.extra,
              ibge: address.ibge,
              extra: address.reference,
              inscEstadual,
            };
            if (response.data.dados && response.data.dados.customerId) {
              customer.customerWinthor = response.data.dados.customerId;
            }
            setCustomer(customer);
            setCustomerId(
              response.data.dados.id
                ? response.data.dados.id
                : response.data.dados.dados.id
            );

            shouldChangeOrderAddressCEP(response.data.dados);
            await updateCartWithCustomer();

            navigate(`/${pluginspace_id}/new-order`);
          } else {
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: response.data.message
                ? response.data.message
                : "Falha ao cadastrar cliente",
            });
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
      return {
        success: false,
        error: error,
      };
    }
  }

  async function continueOrder() {
    try {
      const allValid = validateFields();

      if (!allValid || !allValid.success) {
        return;
      }

      await sendCustomer();
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Algo inesperado aconteceu",
      });
    }
  }

  async function getConfig() {
    setLoadingHeader(true);
    const conf = await getAppConfig();
    setLoadingHeader(false);
    setConfig(conf);
  }

  async function verifyGetCustomer() {
    const customer = await orderContext.getCustomer();
    if (customer.cpf) {
      findCustomerFromCart.current = true;
      setCpfOrCnpj(customer.cpf);
    }
    return;
  }

  async function verifyStatusWhatsapp() {
    // await api
    //   .get(
    //     `/api/zapnis-web/status/${window.atob(
    //       pluginspace_id ? pluginspace_id : ""
    //     )}`,
    //     {
    //       headers: {
    //         Authorization: `Bearer ${await getToken()}`,
    //       },
    //     }
    //   )
    //   .then(async (response) => {
    //     console.log(response);

    //     setWppAvaiable(true);
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setWppAvaiable(false);
    //   });
    // const wppWebActive = await verifyWppWeb();
    try {
      await api
        .post(
          `/api/pluginconfig/filter`,
          {
            plugintemplateId: 31,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (response.data.data[0].content.able === "1") {
            setWppAvaiable(true);
            return;
          } else setWppAvaiable(false);
        })
        .catch((err) => {
          console.log(err);
          setWppAvaiable(false);
        });
    } catch (error) {
      console.log(error);
      setWppAvaiable(false);
    }
  }

  // async function verifyWppWeb() {
  //   try {
  //     const response = await api.get(
  //       `/api/zapnis-web/status/${pluginspace_id}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${await getToken()}`,
  //         },
  //       }
  //     );
  //     return response.data.message.success;
  //   } catch (error) {
  //     console.log(error);
  //     return false;
  //   }
  // }

  async function loadAllData() {
    try {
      setLoading(true);
      await verifyStatusWhatsapp();
      await getConfig();
      await getFieldConfig();
      await getTerms();
      await verifyTotvsFashion();
      await verifyGetCustomer();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  useEffect(() => {
    loadAllData();
  }, []);

  useEffect(() => {
    if (findCustomerFromCart.current && cpfOrCnpj) {
      findCustomerFromCart.current = false;
      findCustomer();
    }
  }, [cpfOrCnpj]);

  /** Fução usada para ativar ou desativar os Alarmes do Endereço */
  function activeAlertAddress() {
    if (
      !address.city ||
      !address.state ||
      !address.street ||
      !address.number ||
      !address.zipCode ||
      !address.district ||
      !address.extra
    ) {
      !address.city && setCityAlarm(true);
      !address.state && setStateAlarm(true);
      !address.street && setStreetAlarm(true);
      !address.number && setNumberAlarm(true);
      !address.zipCode && setAlarmZipCode(true);
      !address.district && setBairroAlarm(true);
      !address.extra && setExtraAlarm(true);

      if (!address.city) {
        callToast("warning", `Necessário inserir uma cidade válida`);
        return;
      }
      if (!address.state) {
        callToast("warning", `Necessário inserir um Estado válido`);
        return;
      }
      if (!address.street) {
        callToast("warning", `Necessário inserir uma rua válida`);
        return;
      }
      if (!address.number) {
        callToast("warning", `Necessário inserir um número válido`);
        return;
      }
      if (!address.zipCode) {
        callToast("warning", `Necessário inserir um CEP válido`);
        return;
      }

      if (!address.district) {
        callToast("warning", `Necessário inserir um bairro válido`);
        return;
      }
      if (!address.extra) {
        callToast("warning", `Necessário inserir um nome do endereço válido`);
        return;
      }

      if (!acceptTerm && config?.content.pdv.termsActive) {
        callToast("warning", `Necessário aceitar os termos de uso`);
        setAlarmAccepTerm(true);
      }
    }
  }

  function desactiveAlertAddress() {
    setCityAlarm(false);
    setStateAlarm(false);
    setStreetAlarm(false);
    setNumberAlarm(false);
    setAlarmZipCode(false);
    setBairroAlarm(false);
    setExtraAlarm(false);
  }
  async function nextStep() {
    try {
      let needToVerify = {
        email: true,
        telephone: true,
        birthdate: true,
      };
      if (haveFieldConfig && fieldsConfig) {
        const emailField = fieldsConfig.find(
          (field: configField) => field.name === "email"
        );
        const birthField = fieldsConfig.find(
          (field: configField) => field.name === "dataNascimento"
        );
        const phoneField = fieldsConfig.find(
          (field: configField) => field.name === "telefone"
        );
        needToVerify.email =
          emailField &&
          emailField.mandatory === true &&
          emailField.visible === true
            ? true
            : false;
        needToVerify.telephone =
          phoneField &&
          phoneField.mandatory === true &&
          phoneField.visible === true
            ? true
            : false;
        needToVerify.birthdate =
          birthField &&
          birthField.mandatory === true &&
          birthField.visible === true
            ? true
            : false;
      }

      if (step === 2) {
        if (
          !address.city ||
          !address.state ||
          !address.street ||
          !address.number ||
          !address.zipCode ||
          !address.district ||
          !address.extra ||
          (!acceptTerm && config?.content.pdv.termsActive) ||
          !name ||
          !cpfOrCnpj ||
          (!email && needToVerify.email) ||
          (!telephone && needToVerify.telephone) ||
          (!birthdate && needToVerify.birthdate && selectedDoc === "cpf") ||
          (!cpf.isValid(cpfOrCnpj) && selectedDoc === "cpf") ||
          (!cnpj.isValid(cpfOrCnpj) && selectedDoc === "cnpj")
        ) {
          activeAlertAddress();
          !name && setAlarmName(true);
          !cpfOrCnpj && setAlarmCpf(true);
          if (!email && needToVerify.email) setAlarmEmail(true);
          if (!telephone && needToVerify.telephone) setAlarmTelephone(true);
          if (!birthdate && needToVerify.birthdate) setAlarmBirthdate(true);

          if (!acceptTerm && config?.content.pdv.termsActive) {
            callToast("warning", `Necessário aceitar os termos de uso`);
            setAlarmAccepTerm(true);
          }
        } else {
          desactiveAlertAddress();
          await continueOrder();
        }
        // fazer criação e tudo mais do usuario e inserir no orderContex
      } else {
        // usar step 2 e cadastrar localização do usuario
        /** Fazer verificações dos campos */
        if (
          (!acceptTerm && config?.content.pdv.termsActive) ||
          !name ||
          !cpfOrCnpj ||
          (!email && needToVerify.email) ||
          (!telephone && needToVerify.telephone) ||
          (!birthdate && needToVerify.birthdate && selectedDoc === "cpf") ||
          (!cnpj.isValid(cpfOrCnpj) && selectedDoc === "cnpj") ||
          (!cpf.isValid(cpfOrCnpj) && selectedDoc === "cpf") ||
          (!email.includes("@") && needToVerify.email) ||
          (new Date(birthdate) >= new Date() &&
            needToVerify.birthdate &&
            selectedDoc === "cpf")
        ) {
          !name && setAlarmName(true);
          !cpfOrCnpj && setAlarmCpf(true);
          if (!email && needToVerify.email) setAlarmEmail(true);
          if (!telephone && needToVerify.telephone) setAlarmTelephone(true);
          if (!birthdate && needToVerify.birthdate) setAlarmBirthdate(true);

          if (!name) {
            callToast("warning", `Necessário inserir um nome válido`);
            return;
          }
          if (!cpfOrCnpj) {
            callToast("warning", `Necessário inserir um documento válido`);
            return;
          }
          if ((!email || !email.includes("@")) && needToVerify.email) {
            callToast("warning", `Necessário inserir um email válido`);
            return;
          }
          if (!telephone && needToVerify.telephone) {
            callToast("warning", `Necessário inserir um telefone válido`);
            return;
          }
          if (
            (!birthdate || new Date(birthdate) >= new Date()) &&
            needToVerify.birthdate &&
            selectedDoc === "cpf"
          ) {
            callToast(
              "warning",
              `Necessário inserir uma data de nascimento válida`
            );
            return;
          }

          if (!acceptTerm && config?.content.pdv.termsActive) {
            callToast("warning", `Necessário aceitar os termos de uso`);
            setAlarmAccepTerm(true);
          }
        } else {
          setAlarmName(false);
          setAlarmCpf(false);
          setAlarmEmail(false);
          setAlarmTelephone(false);
          setAlarmBirthdate(false);
          setAlarmAccepTerm(false);
          setStep(2);
          if (!needToVerify.birthdate || selectedDoc === "cnpj") {
            setBirthdate("2001-10-10");
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  function callToast(type: string, message: string) {
    switch (type) {
      case "success":
        toast.success(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        return;

      case "warning":
        toast.warning(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        return;

      case "error":
        toast.error(message, {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          theme: "light",
          transition: Slide,
        });
        return;
    }
  }

  async function getFieldConfig() {
    const fieldConfig = await api
      .get(`/api/fieldconfig`, {
        headers: {
          Authorization: `Bearer ${await getToken()}`,
        },
      })
      .then(async (response) => {
        return response.data.data[0];
      })
      .catch((err) => {
        console.log(err.data);
        return err;
      });

    setHaveFieldConfig(fieldConfig ? true : false);

    if (fieldConfig) {
      const data: configField[] = [];
      const regexPattern = new RegExp("true");

      Object.entries(fieldConfig.content).map((fieldConfig: any) => {
        data.push({
          visible: regexPattern.test(fieldConfig[1].visible),
          name: fieldConfig[0],
          fieldName: fieldConfig[1].name,
          mandatory: regexPattern.test(fieldConfig[1].mandatory),
        });
      });
      setFieldsConfig(data);
    }
  }

  async function verifyWppToOpen() {
    setLoading(true);
    await api
      .get(
        `/api/zapnis-web/sendCodeConfirm/55${telephoneNoMask(telephone)}@us`,
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.code) {
          setCodeWpp(window.atob(response.data.code));
          setOpenConfirmWpp(true);
        } else {
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Falha ao enviar código de confirmação para o seu celular",
          });
        }
      })
      .catch(() => {
        setUseWpp(false);
        toast.error(
          "Falha ao enviar código de confirmação para o seu celular",
          {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "light",
            transition: Slide,
          }
        );
        setLoading(false);
      });
  }

  return (
    <div className="newCustomer">
      <div className="newCustomer-content">
        {!loadingHeader && (
          <Header
            background={
              config?.webappcolor.backgroundheader
                ? config?.webappcolor.backgroundheader
                : "#F5F5F5"
            }
            colorIcon={
              config?.webappcolor.iconsheader
                ? config.webappcolor.iconsheader
                : "#636363"
            }
            logo={config?.icon ? config.icon : ""}
            backgroundCart={
              config?.webappcolor.backgroundcart
                ? config.webappcolor.backgroundcart
                : "#FFBA49"
            }
            fontCart={
              config?.webappcolor.fontcart
                ? config.webappcolor.fontcart
                : "#000"
            }
            noSales={
              config &&
              config?.content &&
              config?.content.pdv &&
              config?.content.pdv.noSales
                ? config.content.pdv.noSales
                : false
            }
          />
        )}
        {loading ? (
          <div
            style={{
              width: "100vh",
              height: `calc(${loadingHeader ? "100vh" : "100vh - 3em"})`,
            }}
          >
            <Loading
              type="spinningBubbles"
              color="#FFF"
              width={64}
              height={64}
            />
          </div>
        ) : (
          <>
            <div className="new-customer-content">
              <CheckoutOrder position={1} name={"Cadastro"} />
              <div className="new-customer">
                <div className="title">
                  <h3>Informações pessoais</h3>
                  {step === 2 && (
                    <>
                      {showCustomer ? (
                        <BsChevronDown onClick={() => setShowCustomer(false)} />
                      ) : (
                        <BsChevronUp onClick={() => setShowCustomer(true)} />
                      )}
                    </>
                  )}
                </div>
                {showCustomer && (
                  <>
                    {config?.content.pdv.allowSellCnpj && (
                      <div
                        style={{
                          display: "flex",
                          justifyItems: "center",
                          gap: "16px",
                        }}
                      >
                        <Input
                          inputAttr={{
                            type: "radio",
                          }}
                          isSmall
                          label="CPF"
                          name="radio-doc"
                          value={"cpf"}
                          checked={selectedDoc === "cpf"}
                          change={(value: string) => {
                            setCpfOrCnpj("");
                            setSelectedDoc("cpf");
                          }}
                        />
                        <Input
                          inputAttr={{
                            type: "radio",
                          }}
                          isSmall
                          label="CNPJ"
                          name="radio-doc"
                          value={"cnpj"}
                          checked={selectedDoc === "cnpj"}
                          change={(value: string) => {
                            setCpfOrCnpj("");
                            setSelectedDoc("cnpj");
                          }}
                        />
                      </div>
                    )}
                    <Input
                      inputAttr={{
                        type: selectedDoc === "cpf" ? "cpf" : "cnpj",
                      }}
                      label={selectedDoc === "cpf" ? "CPF" : "CNPJ"}
                      value={cpfOrCnpj}
                      warning={alarmCpf}
                      change={(value: string) => {
                        setCpfOrCnpj(value);
                      }}
                      blur={() => findCustomer()}
                    />

                    {selectedDoc === "cnpj" && (
                      <Input
                        inputAttr={{
                          type: "text",
                        }}
                        label="Inscrição Estadual"
                        value={inscEstadual}
                        warning={false}
                        change={(value: string) => {
                          setInscEstadual(value);
                        }}
                      />
                    )}

                    <Input
                      inputAttr={{
                        type: "default",
                      }}
                      label={selectedDoc === "cnpj" ? "Razão social" : "Nome"}
                      value={name}
                      warning={alarmName}
                      change={(value: string) => {
                        setName(value);
                      }}
                      blur={() => {
                        name === undefined || name === ""
                          ? setAlarmName(true)
                          : setAlarmName(false);
                      }}
                    />
                    {((haveFieldConfig &&
                      fieldsConfig.find(
                        (field) => field.name === "email" && field.visible
                      )) ||
                      !haveFieldConfig) && (
                      <Input
                        inputAttr={{
                          type: "email",
                        }}
                        label={
                          haveFieldConfig &&
                          fieldsConfig.find(
                            (field) => field.name === "email" && field.fieldName
                          )
                            ? fieldsConfig.find(
                                (field) =>
                                  field.name === "email" && field.fieldName
                              )?.fieldName
                            : "Email"
                        }
                        value={email}
                        warning={alarmEmail}
                        change={(value: string) => {
                          setEmail(value);
                        }}
                        blur={() => {
                          (email === undefined ||
                            email === "" ||
                            !email.includes("@")) &&
                          (!haveFieldConfig ||
                            (haveFieldConfig &&
                              fieldsConfig.find(
                                (field) =>
                                  field.name === "email" && field.mandatory
                              )))
                            ? setAlarmEmail(true)
                            : setAlarmEmail(false);
                        }}
                      />
                    )}

                    <div className="tel_date">
                      {((haveFieldConfig &&
                        fieldsConfig.find(
                          (field) => field.name === "telefone" && field.visible
                        )) ||
                        !haveFieldConfig) && (
                        <Input
                          inputAttr={{
                            type: "tel",
                          }}
                          label={
                            haveFieldConfig &&
                            fieldsConfig.find(
                              (field) =>
                                field.name === "telefone" && field.fieldName
                            )
                              ? fieldsConfig.find(
                                  (field) =>
                                    field.name === "telefone" && field.fieldName
                                )?.fieldName
                              : "Telefone"
                          }
                          value={telephone}
                          warning={alarmTelephone}
                          change={(value: string) => {
                            setTelephone(value);
                          }}
                          blur={() => {
                            (telephone === undefined ||
                              telephone === "" ||
                              telephone.includes("_")) &&
                            (!haveFieldConfig ||
                              (haveFieldConfig &&
                                fieldsConfig.find(
                                  (field) =>
                                    field.name === "telefone" && field.mandatory
                                )))
                              ? setAlarmTelephone(true)
                              : setAlarmTelephone(false);
                          }}
                        />
                      )}
                      {((haveFieldConfig &&
                        fieldsConfig.find(
                          (field) =>
                            field.name === "dataNascimento" && field.visible
                        )) ||
                        !haveFieldConfig) &&
                        selectedDoc === "cpf" && (
                          <Input
                            inputAttr={{
                              type: "date",
                            }}
                            label={
                              haveFieldConfig &&
                              fieldsConfig.find(
                                (field) =>
                                  field.name === "dataNascimento" &&
                                  field.fieldName
                              )
                                ? fieldsConfig.find(
                                    (field) =>
                                      field.name === "dataNascimento" &&
                                      field.fieldName
                                  )?.fieldName
                                : "Nascimento"
                            }
                            value={birthdate}
                            warning={alarmBirthdate}
                            change={(value: string) => {
                              setBirthdate(value);
                            }}
                            blur={() => {
                              (birthdate === undefined ||
                                birthdate === "" ||
                                birthdate[1] === "_") &&
                              (!haveFieldConfig ||
                                (haveFieldConfig &&
                                  fieldsConfig.find(
                                    (field) =>
                                      field.name === "dataNascimento" &&
                                      field.mandatory
                                  )))
                                ? setAlarmBirthdate(true)
                                : setAlarmBirthdate(false);
                            }}
                          />
                        )}
                    </div>
                    {((haveFieldConfig &&
                      fieldsConfig.find(
                        (field) => field.name === "genero" && field.visible
                      )) ||
                      !haveFieldConfig) &&
                      selectedDoc === "cpf" && (
                        <div className="">
                          <span className="radio_button_title">
                            {haveFieldConfig &&
                            fieldsConfig.find(
                              (field) =>
                                field.name === "genero" && field.fieldName
                            )
                              ? fieldsConfig.find(
                                  (field) =>
                                    field.name === "genero" && field.fieldName
                                )?.fieldName
                              : "Sexo"}
                          </span>
                          <div className="radio_button_div">
                            <Input
                              inputAttr={{
                                type: "radio",
                              }}
                              name="gender"
                              label="Masculino"
                              checked={gender === "masculino"}
                              change={(value: string) => {
                                setGender("masculino");
                              }}
                            />
                            <Input
                              inputAttr={{
                                type: "radio",
                              }}
                              label="Feminino"
                              name="gender"
                              checked={gender === "feminino"}
                              change={(value: string) => {
                                setGender("feminino");
                              }}
                            />
                            <Input
                              inputAttr={{
                                type: "radio",
                              }}
                              label="Não informar"
                              name="gender"
                              value={gender}
                              checked={gender === "none"}
                              change={(value: string) => {
                                setGender("none");
                              }}
                            />
                          </div>
                        </div>
                      )}

                    {/* {wppAvaiable && (
                      <div className="">
                        <div className="radio_button_div">
                          <Input
                            inputAttr={{
                              type: "checkbox",
                            }}
                            name="whastApp"
                            label="Aceita receber mensagens pelo Whatsapp?"
                            placeholder="Aceita receber mensagens pelo Whatsapp?"
                            checked={useWpp}
                            change={(value: boolean) => {
                              setUseWpp(value);
                            }}
                          />
                        </div>
                      </div>
                    )} */}

                    {wppAvaiable && (
                      <div className="wpp-container">
                        <div className="wpp-icon">
                          <svg
                            width="26"
                            height="26"
                            viewBox="0 0 26 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M0 25.8516C0.634451 24.0954 1.19841 22.55 1.76236 21.0045C2.11484 20.2318 2.04433 19.5995 1.62137 18.8268C-2.96078 10.2566 3.24275 -0.0698915 13.0415 0.000356456C19.386 0.000356456 24.8846 4.84747 25.7305 11.1698C26.8584 19.3888 20.0204 26.4838 11.7021 25.6409C10.4332 25.5004 9.09376 25.0086 7.89535 24.5169C7.11991 24.2359 6.48548 24.0954 5.71004 24.3764C4.08867 24.8681 2.4673 25.2896 0.91642 25.7111C0.634442 25.7111 0.422967 25.7111 0 25.8516ZM16.3547 19.8103C17.9056 19.8103 19.0335 19.1078 19.5975 18.1243C20.2319 17.0004 20.0204 16.1574 18.822 15.5252C18.6105 15.3847 18.3286 15.2442 18.0466 15.1739C16.3547 14.3309 16.3547 14.2607 15.2268 15.7359C14.8038 16.2979 14.3809 16.3681 13.8169 16.0169C12.1955 15.1739 10.9266 13.9797 9.93971 12.5045C9.51675 11.8723 9.44623 11.3103 10.0102 10.678C10.4332 10.1863 10.7152 9.62433 10.4332 8.92185C10.0807 8.07887 9.79871 7.2359 9.44624 6.46317C9.23476 5.90119 8.8118 5.69045 8.17735 5.76069C6.69696 5.97144 5.35757 8.14913 5.71004 9.69458C6.69696 13.5582 9.09378 16.3681 12.407 18.4053C13.7464 19.2483 15.0858 19.74 16.3547 19.8103Z"
                              fill="#25D366"
                            />
                          </svg>
                        </div>
                        <div className="wpp-info">
                          <p className="wpp-text">
                            Aceito ser comunicado via WhatsApp sobre promoções,
                            status de pedidos
                          </p>
                          {wppAvaiable && (
                            <div className="wpp-options">
                              <div className="wpp-option">
                                <input
                                  type="radio"
                                  id="accept-wpp"
                                  name="whatsapp"
                                  checked={useWpp === true}
                                  onChange={() => setUseWpp(true)}
                                />
                                <label htmlFor="accept-wpp">Aceito</label>
                              </div>
                              <div className="wpp-option">
                                <input
                                  type="radio"
                                  id="decline-wpp"
                                  name="whatsapp"
                                  checked={useWpp === false}
                                  onChange={() => setUseWpp(false)}
                                />
                                <label htmlFor="decline-wpp">Não aceito</label>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {config?.content.pdv.termsActive && (
                      <div className="info-container">
                        <div className="radio_button_div">
                          {!openTerms && (
                            <Input
                              inputAttr={{
                                type: "checkbox",
                              }}
                              label="Aceita o termo de uso?"
                              placeholder="Aceita os "
                              name="terms"
                              warning={alarmAccepTerm}
                              isSmall={true}
                              checked={acceptTerm}
                              value={acceptTerm}
                              /* disabled={!readTerm} */
                              change={(value: boolean) => {
                                setAcceptTerm(value);
                              }}
                            />
                          )}
                          <span
                            className="link"
                            onClick={() => {
                              setOpenTerms(true);
                            }}
                          >
                            {" "}
                            Ler o termo.
                          </span>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              {step === 2 && (
                <CustomerAddress
                  address={address}
                  setAddress={setAddress}
                  showCustomerAddress={showCustomerAddress}
                  setShowCustomerAddress={setShowCustomerAddress}
                  setLoading={setLoading}
                  activeAlarm={activeAlarm}
                  stateAlarm={stateAlarm}
                  cityAlarm={cityAlarm}
                  streetAlarm={streetAlarm}
                  numberAlarm={numberAlarm}
                  zipCodeAlarm={zipCodeAlarm}
                  bairroAlarm={bairroAlarm}
                  extraAlarm={extraAlarm}
                  desactiveAlarms={desactiveAlertAddress}
                  customerAddresses={customerAddresses}
                />
              )}
            </div>
            <ButtonCheckout
              action={() =>
                !confirmWpp && useWpp && !customerValidationRegister
                  ? verifyWppToOpen()
                  : nextStep()
              }
              label={"Continuar"}
              backgroundColor={
                config?.webappcolor.webappbutton
                  ? config.webappcolor.webappbutton
                  : "#EAEAEA"
              }
              color={
                config?.webappcolor.fontbutton
                  ? config?.webappcolor.fontbutton
                  : "#636363"
              }
            />
          </>
        )}
      </div>
      {openTerms && (
        <NewModalTerms
          isOpen={openTerms}
          setIsOpen={setOpenTerms}
          termContent={term}
          backgroundButton={
            config?.webappcolor.webappbutton && config.webappcolor.webappbutton
          }
          fontButton={
            config?.webappcolor.fontbutton && config.webappcolor.fontbutton
          }
          acceptTerm={acceptTerm}
          setAcceptTerm={setAcceptTerm}
          setReadTerms={setReadTerms}
          readTerm={readTerm}
        />
      )}

      {openConfirmWpp && (
        <ModalConfirmWpp
          isOpen={openConfirmWpp}
          setIsOpen={setOpenConfirmWpp}
          code={codeWpp}
          setConfirm={setConfirmWpp}
          backgroundButton={
            config?.webappcolor.webappbutton && config.webappcolor.webappbutton
          }
          fontButton={
            config?.webappcolor.fontbutton && config.webappcolor.fontbutton
          }
          customerId={customerId}
          setConfirmValidationRegister={setConfirmValidationRegister}
        />
      )}
    </div>
  );
};

export { NewCustomer };

type AddressCustomer = {
  zipCode: string;
  street: string;
  number: string;
  district: string;
  city: string;
  state: string;
  extra: string;
  reference: string;
  typeAddress: string;
  ibge: string;
};

type CustomerAddressProps = {
  setAddress: (value: AddressCustomer) => void;
  setShowCustomerAddress: (value: boolean) => void;
  address: AddressCustomer;
  showCustomerAddress: boolean;
  activeAlarm: boolean;

  setLoading: (value: boolean) => void;
  desactiveAlarms: () => void;

  stateAlarm: boolean;
  cityAlarm: boolean;
  streetAlarm: boolean;
  numberAlarm: boolean;
  zipCodeAlarm: boolean;
  bairroAlarm: boolean;
  extraAlarm: boolean;

  customerAddresses: any[];
};

const CustomerAddress: FC<CustomerAddressProps> = ({
  setAddress,
  address,
  showCustomerAddress,
  setShowCustomerAddress,
  setLoading,
  stateAlarm,
  cityAlarm,
  streetAlarm,
  numberAlarm,
  zipCodeAlarm,
  bairroAlarm,
  extraAlarm,
  desactiveAlarms,
  customerAddresses,
}) => {
  async function findCep(cep: string, firstSearch?: boolean) {
    const data = customerAddresses.find(
      (el) => el.zipCode === cep.replace("-", "")
    );

    if (data) {
      let zipCode = data.zipCode;
      let street = data.street;
      let number = data.number;
      let extra = data.extra;
      let district = data.district;
      let city = data.city;
      let state = data.state;
      let ibge = data.ibgeCode;
      setAddress({
        zipCode: zipCode,
        street: street,
        number: number,
        district: district,
        city: city,
        state: state,
        extra: extra,
        reference: "",
        typeAddress: "main",
        ibge: ibge,
      });

      return;
    }

    if (cep) {
      setLoading(true);
      return await api
        .get(`https://viacep.com.br/ws/${cep.replace("-", "")}/json/`)
        .then((response) => {
          if (response.data.erro) {
            setLoading(false);
            Swal.fire({
              icon: "warning",
              title: "CEP inválido!",
              text: "Verifique se o CEP foi digitado corretamente.",
            });
            return false;
          } else {
            const data = response.data;

            setAddress({
              zipCode: data.cep,
              street: data.logradouro,
              number: "",
              district: data.bairro,
              city: data.localidade,
              state: data.uf,
              extra: "",
              reference: "",
              typeAddress: "main",
              ibge: data.ibge,
            });
            desactiveAlarms();
            setLoading(false);
            return true;
          }
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: "CEP inválido!",
            text: "Verifique se o CEP foi digitado corretamente.",
          });
          setLoading(false);
          return false;
        });
    } else {
      return false;
    }
  }

  return (
    <div className="new-customer-address">
      <div className="title">
        <h3>Endereço de cadastro</h3>
        {showCustomerAddress ? (
          <BsChevronDown onClick={() => setShowCustomerAddress(false)} />
        ) : (
          <BsChevronUp onClick={() => setShowCustomerAddress(true)} />
        )}
      </div>
      {showCustomerAddress && (
        <>
          <Input
            inputAttr={{
              type: "cep",
            }}
            label="Cep"
            value={address.zipCode}
            warning={zipCodeAlarm}
            change={(value: string) => {
              setAddress({ ...address, zipCode: value });
            }}
            blur={(value) => findCep(value)}
          />

          <div className="two-inputs_equals">
            <Input
              inputAttr={{
                type: "select",
              }}
              label="Estado"
              value={address.state}
              warning={stateAlarm}
              change={(value: string) => {
                setAddress({ ...address, state: value });
              }}
            />
            <Input
              inputAttr={{
                type: "default",
              }}
              label="Cidade"
              placeholder="Cidade"
              value={address.city}
              warning={cityAlarm}
              change={(value: string) => {
                setAddress({ ...address, city: value });
              }}
            />
          </div>

          <div className="two-inputs_equals">
            <Input
              inputAttr={{
                type: "default",
              }}
              label="Endereço"
              value={address.street}
              placeholder="Rua das macarenas"
              change={(value: string) => {
                setAddress({ ...address, street: value });
              }}
              warning={streetAlarm}
            />
            <Input
              inputAttr={{
                type: "number",
              }}
              isSmall
              label="Número"
              placeholder="000"
              value={address.number}
              warning={numberAlarm}
              change={(value: string) => {
                setAddress({ ...address, number: value });
              }}
            />
          </div>
          <Input
            inputAttr={{
              type: "default",
            }}
            label="Bairro"
            value={address.district}
            warning={bairroAlarm}
            change={(value: string) => {
              setAddress({ ...address, district: value });
            }}
            placeholder="Bairro"
          />

          <Input
            inputAttr={{
              type: "default",
            }}
            label="Complemento (Opcional)"
            value={address.reference}
            change={(value: string) => {
              setAddress({ ...address, reference: value });
            }}
            placeholder="Complemento"
          />
          <Input
            inputAttr={{
              type: "default",
            }}
            label="Nome deste endereço"
            value={address.extra}
            warning={extraAlarm}
            change={(value: string) => {
              setAddress({ ...address, extra: value });
            }}
            placeholder="(Exemplo: casa, trabalho, etc)"
          />
        </>
      )}
    </div>
  );
};
